import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import { pagesAPI } from '../services/api';

const Footer = ({ onRegisterClick }) => {
  const [wacanaLinks, setWacanaLinks] = useState([]);

  useEffect(() => {
    pagesAPI.getAll()
      .then(res => setWacanaLinks(res.pages || []))
      .catch(() => setWacanaLinks([]));
  }, []);

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Brand Section */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo-af.png" alt="Akademia Fitrah" className="w-10 h-10 object-contain" />
              <div className="flex flex-col">
                <span className="text-sm font-medium text-gray-400 leading-tight">Akademia</span>
                <span className="text-2xl font-bold text-white -mt-0.5">FITRAH</span>
              </div>
            </div>
            <p className="text-gray-400 max-w-md">
              Platform pendidikan berbasis kesadaran fitrah untuk guru dan orang tua.
            </p>
            <p className="text-gray-500 text-sm mt-2">
              Sadar &ndash; Belajar &ndash; Refleksi &ndash; Dialog &ndash; Bertumbuh
            </p>
          </div>

          {/* 3-Column Grid */}
          <div className="grid md:grid-cols-3 gap-12">
            {/* Jelajah */}
            <div>
              <h4 className="font-bold text-white mb-6">Jelajah</h4>
              <ul className="space-y-3">
                <li>
                  <button onClick={onRegisterClick} className="text-gray-400 hover:text-blue-400 transition-colors text-left">
                    Mulai Perjalanan
                  </button>
                </li>
                <li>
                  <a href="#perjalanan" className="text-gray-400 hover:text-blue-400 transition-colors">
                    Peta Perjalanan
                  </a>
                </li>
                <li>
                  <a href="#mulai-belajar" className="text-gray-400 hover:text-blue-400 transition-colors">
                    Kursus
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                    Forum
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                    Jurnal Refleksi
                  </a>
                </li>
              </ul>
            </div>

            {/* Wacana & Nilai */}
            <div>
              <h4 className="font-bold text-white mb-6">Wacana & Nilai</h4>
              <ul className="space-y-3">
                {wacanaLinks.map((page) => (
                  <li key={page.slug}>
                    <Link
                      to={`/halaman/${page.slug}`}
                      className="text-gray-400 hover:text-blue-400 transition-colors"
                    >
                      {page.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Terhubung */}
            <div>
              <h4 className="font-bold text-white mb-6">Terhubung</h4>
              <ul className="space-y-3">
                <li>
                  <a href="https://tiktok.com/@rohmani.id" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                    TikTok
                  </a>
                </li>
                <li>
                  <a href="https://facebook.com/rohmani24" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                    Facebook
                  </a>
                </li>
                <li>
                  <a href="https://instagram.com/rohmani.id" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                    Instagram
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/@rohmani.24" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                    YouTube
                  </a>
                </li>
                <li className="flex items-start gap-2 text-gray-400 pt-2">
                  <Mail className="w-4 h-4 mt-0.5 text-blue-400 shrink-0" />
                  <span>info@akademiafitrah.id</span>
                </li>
                <li className="flex items-start gap-2 text-gray-400">
                  <MapPin className="w-4 h-4 mt-0.5 text-blue-400 shrink-0" />
                  <span>Jakarta, Indonesia</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-gray-400 text-sm text-center">
            &copy; 2026 Akademia Fitrah. Hak cipta dilindungi.
          </p>
          <p className="text-gray-500 text-xs text-center mt-2">
            <a href="#" className="hover:text-gray-300 transition-colors">Kebijakan Privasi</a>
            <span className="mx-2">&middot;</span>
            <a href="#" className="hover:text-gray-300 transition-colors">Syarat &amp; Ketentuan</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
